import { createSelector } from 'reselect'

import { getCurrentMediaTitle } from '../currentMedia/selectors'
import {
    getAppName,
    getToolbarShareEmailBody
} from '../app/selectors'
import { getConfiguration } from '../configuration/selectors'

export const getShareMailBody = createSelector(
    getToolbarShareEmailBody,
    state => encodeURIComponent(window.location.href),
    (toolbarShareEmailBody, currentMediaUrl) => (
        toolbarShareEmailBody
            .replace(/{{pageUrl}}/g, currentMediaUrl)
            .split("\n").join("%0D%0A")
    )
)

export const getShareMailSubject = createSelector(
    getAppName,
    getCurrentMediaTitle,
    (appName, currentMediaTitle) => `${appName} - ${currentMediaTitle.recordTitle.trim()}`
)

export const isSocialSharingOpened = state => state.share.isOpened

export const getShareActions = createSelector(
    getConfiguration,
    configuration => [ configuration.share ]
)
